module.exports = __webpack_public_path__ + "img/p-three-step-08.b0aa7673.png";